import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type Props = {
  label: string;
  children: ReactNode;
  separator?: ':' | string;
  className?: string;
};

function LabeledVertical({
  label,
  children,
  separator = ':',
  className,
}: Props) {
  return (
    <div className={cn(className)}>
      <p className="text-xs font-semibold mb-1 text-muted-foreground">
        {label}
        {separator}
      </p>
      <>{children}</>
    </div>
  );
}

export default LabeledVertical;
